export const getFieldFromBinary = (filters, position) => {
  // Для преобразования бинарного кода некоторых полей которые приходят с сервера
  const binaryString = Number(filters).toString(2).split('').reverse().join('');
  return parseInt(binaryString[position] || 0);
};

export const getPropsByName =(arr, propName)=>{
  return arr.map((obj)=>{
    return obj[propName];
  });
};

export const uniq = (arr)=>{
  return arr.filter((val, index, arr) => arr.indexOf(val) === index);
};
export const sortBy = (arr, fieldToSort) =>{
  return arr.sort((a, b)=>{
    if (a[fieldToSort] > b[fieldToSort]) {
      return 1;
    }
    if (a[fieldToSort] < b[fieldToSort]) {
      return -1;
    }
    return 0;
  });
};

export const upperFirst = (str) =>{
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const debounce = function(func, wait, immediate) {
  let timeout;
  return function() {
    const context = this;
    const args = arguments;
    const later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};
export const capitalise = (str) => {
  return str.charAt(0).toUpperCase() + str.substr(1);
};

export const getArbInfoForURLQuery = (arbInfo, betsHashList) =>{
  // Для декодирования информации о вилке в строку запроса. Используется для открытия калькулятора в отдельном окне
  // Возвращает урезанный обьект с минимальной инфой по вилке, чтобы не было ошибки по длине URL
  const bets = [];
  const betsIds = [arbInfo.bet1_id, arbInfo.bet2_id, arbInfo.bet3_id];
  betsIds.forEach((id)=>{
    const bet = betsHashList[id];
    bet ? bets.push(bet) : null;
  });

  return {
    id: arbInfo.id,
    arb_formula_id: arbInfo.arb_formula_id,
    arb_hash: arbInfo.arb_hash,
    bet1_id: arbInfo.bet1_id,
    bet2_id: arbInfo.bet2_id,
    bet3_id: arbInfo.bet3_id,
    bk_ids: arbInfo.bk_ids,
    created_at: arbInfo.created_at,
    event_name: arbInfo.event_name,
    sport_id: arbInfo.sport_id,
    name: arbInfo.name,
    country_id: arbInfo.country_id,
    league: arbInfo.league,
    percent: arbInfo.percent,
    middle_value: arbInfo.middle_value,
    started_at: arbInfo.started_at,
    event_id: arbInfo.event_id,
    league_id: arbInfo.league_id,
    home_id: arbInfo.home_id,
    away_id: arbInfo.away_id,
    bets: bets.map((bet)=>{
      return {
        id: bet.id,
        bookmaker_id: bet.bookmaker_id,
        commission: bet.commission,
        diff: bet.diff,
        koef: bet.koef,
        koef_lay: bet.koef_lay,
        market_depth: bet.market_depth,
        period_identifier: bet.period_identifier,
        bookmaker_league_name: bet.bookmaker_league_name,
        bookmaker_event_name: bet.bookmaker_event_name,
        team1_name: bet.team1_name,
        market_and_bet_type: bet.market_and_bet_type,
        market_and_bet_type_param: bet.market_and_bet_type_param,
        sport_id: arbInfo.sport_id,
      };
    }),
  };
};
